module.exports = __webpack_public_path__ + "static/media/repair_blue.ff083cdc.svg";